import Vue from "vue";
import { store } from "../../store/store";
import { i18n } from "../../main";
import router from "../../router";

import { isDemoError } from "@/helpers/handlers/demoService";
import { GTM_EVENT_NAME } from "@/enums/gtm-events";
import { FEATURE_FLAG, isFeatureFlagEnabled } from "@/helpers/posthog";

class ErrorHandler {
  displayError(error) {
    if (isDemoError(error)) {
      // in case of demo version of the app, request is cancelled and only demo modal is shown
      const demoModalData = {
        text: i18n.t("message.demoService.modal.text"),
        buttonText: i18n.t("message.demoService.modal.buttonText"),
        maxWidth: 590,
        textCenter: true,
        contactUsBtn: true
      };

      store.dispatch("settings/openModal", demoModalData);
      return;
    }

    const status = error.response
      ? error.response.status
      : Number(error.message);
    this._checkErrorType(error, status);
  }

  displayDefaultError() {
    this._showError(i18n.t("message.error.other"));
  }

  _checkErrorType(error, status) {
    let message = "";
    const setMessage = errPath => {
      if (typeof errPath === "string") {
        message = errPath;
      } else {
        errPath = Array.isArray(errPath)
          ? errPath[0]
          : Object.values(errPath)[0];
        setMessage(errPath);
      }
    };

    setMessage(error && error.response ? error.response.data : "");
    switch (status) {
      case 400:
      case 403:
        this._showError(message);
        break;
      case 401:
        this._showError(i18n.t("message.error.unauthorized"));

        if (router.currentRoute.name !== "session-login") {
          router.push({ name: "session-login" });
        }
        break;
      case 404:
        this._showError(i18n.t("message.error.notFound"));
        break;
      case 503:
        Vue.gtm.trackCustomEvent({
          event: GTM_EVENT_NAME.ERROR_SERVICE_UNAVAILABLE
        });
        router.push({ name: "maintenance-mode" });
        break;
      case 500:
        if (
          process.env.NODE_ENV !== "development" &&
          isFeatureFlagEnabled(FEATURE_FLAG.SERVICE_UNAVAILABLE)
        ) {
          router.push({ name: "maintenance-mode" });
        } else {
          this._showError(i18n.t("message.error.server"));
        }
        break;
      default:
        this._showError(i18n.t("message.error.other"));
    }
  }

  _showError(error) {
    Vue.notify({
      group: "default",
      type: "error",
      text: error
    });
  }
}

export default new ErrorHandler();
